import { memo, useEffect, useMemo, useState } from 'react';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { isFeatureEnabledForActiveModule } from 'src/helpers/module_helper';
import useMailboxRoleAccess from 'src/modules/mailer/hooks/useMailboxRoleAccess';
const Tabs = memo(({
    t,
    modules
}) => {
    const [activeTab, setActiveTab] = useState("");
    const history = useHistory();
    const location = useLocation();
    const { canOpenSettings } = useMailboxRoleAccess();

    const isActiveTab = (currentTab, tab) => currentTab === tab;

    const tabsItems = useMemo(() => {
        const tabs = [
            {
                key: "qr",
                title: "QR Code"
            },
            {
                key: "risk-customization",
                title: "Risk Customization"
            }
        ];
        
        if(modules.featuresLoadingStatus === 'loaded' && isFeatureEnabledForActiveModule('news_monitoring')) {
            tabs.push({
                key: "news-monitoring",
                title: "News Monitoring"
            });
        }

        tabs.push({
            key: "routing",
            title: "Routing"
        });

        if(modules.featuresLoadingStatus === 'loaded' && isFeatureEnabledForActiveModule('email-notifications')) {
            tabs.push({
                key: "organization-email-notifications",
                title: "Organization Email Notifications"
            });
        }

        if(modules.featuresLoadingStatus === 'loaded' && isFeatureEnabledForActiveModule('mailer') && canOpenSettings) {
            tabs.push({
                key: "email-settings",
                title: "Email Settings"
            });
        }

        tabs.push({
            key: "compliance-frameworks",
            title: "Frameworks"
        });

        if (modules.featuresLoadingStatus === 'loaded' && isFeatureEnabledForActiveModule('confluence_setting')) {
            tabs.push({
                key: "confluence-settings",
                title: "Confluence Settings"
            });
        }

        return tabs;
    }, [
        modules.featuresLoadingStatus,
        canOpenSettings,
    ]);

    useEffect(() => {
        const tabKey = (new URLSearchParams(location.search)).get('tab');
        const tab = (tabsItems.find((tab) => tab.key === tabKey))?.key;

        if(!tab) {
            history.push({
                search: '?tab=qr'
            });
        }
        else{
            setActiveTab(tab);
        }
    }, [
        location.search,
        tabsItems,
        history
    ]);

    return (
        <div style={{
            backgroundColor: '#D1D2D6',
        }}>
            <Nav tabs className="custom-style-1">
                {
                    tabsItems.map((link) => {
                        return (
                            <NavItem 
                                className={isActiveTab(activeTab, link.key) ? 'active' : ''} 
                                key={link.key}
                            >
                                <NavLink
                                    className={isActiveTab(activeTab, link.key) ? 'active' : ''}
                                    onClick={() => history.push({
                                        search: '?tab=' + link.key
                                    })}
                                >
                                    {t(link.title)}
                                </NavLink>
                            </NavItem>
                        )
                    })
                }
            </Nav>
        </div>
    );
});

const mapStatetoProps = (state) => {
    const { Modules } = state;

    return {
        modules: Modules
    };
};


export default withNamespaces()(
    withRouter(connect(mapStatetoProps)(Tabs))
);
